export const environment = {
  production: true,
  apiUrl: 'https://portal.kidl.org.pl:4000/',
  passwordMinLenght: 8,
  passwordRegex: "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*()\\-=_+\\[\\]{};':\",.<>\\/\\\|~`])[A-Za-z\\d!@#$%^&*()\\-=_+\\[\\]{};':\",.<>\\/\\\|~`]{8,}$"
};
